import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const About: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>About AskTheBill.ai</Typography>
      <Typography variant="body1" paragraph>
        AskTheBill.ai is a non-partisan project that helps people explore legislation, members of Congress, votes, and committees using public data from Congress.gov.
        Our goal is to make complex policy easier to understand and to encourage informed civic engagement.
      </Typography>
      <Typography variant="body1" paragraph>
        The site provides searchable bills, lawmaker profiles, recent vote activity, and AI-assisted summaries to highlight key points.
        AI features are designed to reflect the data we’ve ingested and are continuously improving.
      </Typography>
      <Typography variant="body1" paragraph>
        If you have feedback or suggestions, please reach out via our Contact page. We appreciate your input as we continue building useful tools for the public.
      </Typography>
    </Paper>
  );
};

export default About;
